export default __webpack_public_path__ + "static/gilroy-bold-2d3722cd63f298fe4d2f7db3da073ac8.woff";